import { PlatformRequestService } from "./PlatformRequestService";
export class PlatformV2RequestService extends PlatformRequestService {
    getParsedToken(response) {
        let parsedResponse = JSON.parse(response);
        if (!parsedResponse.token) {
            throw new Error("Token is not available");
        }
        return parsedResponse.token;
    }
}
//# sourceMappingURL=PlatformV2RequestService.js.map